/**
 * Redakční systém JSR
 * reset.js
 * JQuery funkce pro stránku resetu hesla do uživ. účtu
 *
 * @author Josef Šmíd <josef@skit.cz>
 * @copyright (c) 2007-2017 Josef Šmíd
 * @version 2.0.0
 */

$(document).ready(function() 
{
  //timeout tady přepíše chování browseru, který předvyplňuje uložená hesla
  setTimeout( function()
  { 
    if ( $('#setnewpwd_button').length > 0 ) $('#reset_password').select();
    else $('#reset_username').select();
  }, 500 );
  
  //kliknutí na tlačítko uložit zahashuje v případě změny hesla zadané heslo, aby se nepřenášelo v nešifrované formě
  $('#setnewpwd_button').click( function() 
  {
    // Create a new element input, this will be our hashed password field. 
    var p1 = document.createElement( "input" );
    var p2 = document.createElement( "input" );

    // Add the new element to our form. 
    $('#setnewpwd_button').before( p1 );
    $('#setnewpwd_button').before( p2 );

    p1.name = "p1hash";
    p1.type = "hidden";
    p1.value = hex_sha512( $('#reset_password').val() );

    p2.name = "p2hash";
    p2.type = "hidden";
    p2.value = hex_sha512( $('#reset_password2').val() );

    // Make sure the plaintext password doesn't get sent. 
    $('#reset_password').val( '' );
    $('#reset_password2').val( '' );
  });
});